import { z } from 'zod'

export const sendResetPasswordTokenSchema = z.object({
  email: z
    .string({ message: 'Email é obrigatório' })
    .min(1, { message: 'Email é obrigatório' })
    .email({ message: 'Email inválido' }),
})

export type SendResetPasswordTokenSchema = z.infer<
  typeof sendResetPasswordTokenSchema
>
